import { Button } from "reactstrap";
import './IconButton.css';

function IconButton({ children, ...props }) {
  return(
    <Button {...props} className={"btn-icon" + (props.className ? " " + props.className : "")}>
      { children }
    </Button>
  );
}

export default IconButton;